<a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
  <cx-media
    [container]="item.images"
    format="product"
    [alt]="item?.name"
    class="border border-primary"
  ></cx-media>
  <h4 class="text-center text-primary mt-1">
    {{ item.name }}
  </h4>
  <p class="text-center text-secondary my-1">
    {{ item?.code }}
  </p>
  <p class="text-center text-secondary my-1">
    {{ item?.manufacturer}}
  </p>

  <div class="price">
    {{ $any(item)?.redPrice?.formattedValue }}
  </div>
</a>
<div class="actions">
  <ng-container cxInnerComponentsHost></ng-container>
</div>
